import React from "react";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useInsight } from "./InsightContext";

/**
 * InsightToggle — the persistent "Help & Insights" pill.
 *
 * Placed in the top utility bar on every authenticated surface.
 * Light-switch behavior: a single click toggles Insight Mode on/off from
 * anywhere in the portal. The pill reflects current state.
 *
 * `variant="light"` renders for the legacy white utility bar; default styling
 * is tuned for the dark Operational Base shell.
 */
const InsightToggle = ({ variant = "dark" }) => {
    const { t } = useTranslation();
    const { active, toggle } = useInsight();
    return (
        <button
            type="button"
            onClick={toggle}
            data-insight-system="toggle"
            data-active={active ? "true" : "false"}
            data-testid="insight-toggle"
            aria-pressed={active}
            aria-label={active ? t("insight.toggle.exit_aria") : t("insight.toggle.open_aria")}
            className={`insight-toggle ${variant === "light" ? "insight-toggle--light" : ""}`.trim()}
        >
            <Sparkles size={13} strokeWidth={1.7} />
            <span>{t("insight.toggle.label")}</span>
        </button>
    );
};

export default InsightToggle;
